import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import {
  ReviewSurveyReport,
  ReviewSurveyReportResponse,
} from 'ha/services/apiV2/types/ReviewSurveyReport';

export default (makeCall: MakeCall) =>
  ({ surveyUUID, payload }: ReviewSurveyReport) =>
    makeCall<ReviewSurveyReportResponse>(
      'POST',
      `/api/v2/review/survey/${surveyUUID}/report`,
      {
        data: { payload },
      },
    );
